import Input from '../../Atoms/Input/Input'
import { InputStyleProps } from 'src/components/Atoms/Input/types'
import styled, { css } from 'styled-components'
import Flex from '../../Layout/Flex/Flex'
import { DayDataCellType, CalendarType } from './types'

export const DatePickerWrapper = styled('div') <{ gridArea?: string }>`
  position: relative;

  ${props => props.gridArea && css`
      grid-area: ${props.gridArea};
  `}
`
export const InputStyle = styled(Input) <InputStyleProps>`
  ${props =>
    props.error &&
    css`
      border: 1px solid ${props => props.theme.colors.main.error};
    `}
`

export const CalendarWrapper = styled(Flex) <CalendarType>`
  z-index: 100;
  position: absolute;
  display: ${props => props.isOpen ? 'block' : 'none'};
  opacity: ${props => props.isOpen ? '1' : '0'};
  width: 238px;
  background-color: ${props => props.theme.colors.main.background};
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px;
  transition: opacity 0.3s ease-in-out;
  transform: translateY(${props => props.marginBottom ? '-8px' : '-16px'});
`

export const DayCell = styled(Flex) <DayDataCellType>`
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  padding: 0px;

  appearance: none;
  border: none;
  background-color: transparent;

  h6 {
    user-select: none;
  }

  ${props => !props.disabled && props.isBody && props.isCurrentMonth && css`
    cursor: pointer;
  `}

  ${props => (props.disabled || (props.isBody && !props.isCurrentMonth)) && css`
    h6 {
      color: ${props.theme.colors.shades.neutral[1]};
    }
  `}
`
